import axios, { type AxiosInstance } from 'axios';
import { authInterceptor, refreshInterceptor } from './interceptors/auth';
import { errorInterceptor } from './interceptors/error';
import { telemetryInterceptor } from './interceptors/telemetry';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

export const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15_000,
});

authInterceptor(api);
refreshInterceptor(api);
errorInterceptor(api);
telemetryInterceptor(api);
